import { LinkDetails } from "api/interfaces/product-api.type";

export function isValidLink(obj: LinkDetails) {
  if (!obj) {
    return false;
  }
  const keys = ["image", "minimumPrice", "maximumPrice", "description"];
  return keys.every((key) => obj[key]);
}
